import { render } from "./Cookies.vue?vue&type=template&id=712d30a2&scoped=true"
import script from "./Cookies.vue?vue&type=script&lang=js"
export * from "./Cookies.vue?vue&type=script&lang=js"

import "./Cookies.vue?vue&type=style&index=0&id=712d30a2&lang=scss"
import "./Cookies.vue?vue&type=style&index=1&id=712d30a2&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src1959521788/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-712d30a2"]])

export default __exports__